import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from './Input';
import Textarea from './Textarea';
import { FaPaperPlane } from 'react-icons/fa';
import GeneralData from '../../../generalData';
import { FORM_CONTACTO_ENDPOINT } from '../../../configs';
import router from '../../../router';

const ContactForm = (props) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    cellphone: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setErrorMessage('');
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};

    if (!formData.name) {
      newErrors.name = 'El nombre es obligatorio';
      isValid = false;
    }
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Correo electrónico inválido';
      isValid = false;
    }
    if (!formData.cellphone || !/^\d+$/.test(formData.cellphone)) {
      newErrors.cellphone = 'Número de teléfono inválido';
      isValid = false;
    }
    if (!formData.message) {
      newErrors.message = 'El mensaje no puede estar vacío';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        setLoading(true);

        const origin = window.location;
        const body = { ...formData, origin: origin.href };

        const response = await fetch(FORM_CONTACTO_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        if (response.ok) {
          const data = await response.json();

          if (data.Validacion) {
            setFormData({ name: '', email: '', cellphone: '', message: '' });
            navigate(router.successEnvioDeFormulario);
          } else {
            const errorMessage = data.Validacion_mensaje;
            setErrorMessage(errorMessage);
          }
        } else {
          setErrorMessage(`Error al enviar formulario: ${response.statusText}`);
        }

        setLoading(false);
      } catch (error) {
        setErrorMessage(`Error al enviar formulario: ${error.message}`);
        setLoading(false);
      }
    }
  };
  return (
    <div className="p-8 rounded-xl bg-primary-50 flex flex-col  gap-8 w-full text-lg border">
      {props.title && (
        <div>
          <strong>{props.title}</strong>
        </div>
      )}
      <form
        style={{
          opacity: loading ? '0.5' : '1',
          pointerEvents: loading ? 'none' : 'auto',
        }}
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 items-start"
      >
        <div className="w-full">
          <Input
            label="Nombre"
            name="name"
            required
            onChange={handleChange}
            value={formData.name}
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
        </div>

        <div className="w-full">
          <Input
            label="Email"
            name="email"
            type="email"
            required
            onChange={handleChange}
            value={formData.email}
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email}</p>
          )}
        </div>
        <div className="w-full">
          <Input
            label="Celular"
            name="cellphone"
            required
            onChange={handleChange}
            value={formData.cellphone}
          />
          {errors.cellphone && (
            <p className="text-red-500 text-sm">{errors.cellphone}</p>
          )}
        </div>

        <div className="w-full">
          <Textarea
            name="message"
            placeholder="Mensaje"
            onChange={handleChange}
            value={formData.message}
          />
          {errors.message && (
            <p className="text-red-500 text-sm">{errors.message}</p>
          )}
        </div>

        {errorMessage && (
          <div>
            <p className="text-red-500 text-sm bg-red-50 rounded-lg p-4 border border-solid border-red-300">
              {errorMessage}
            </p>
          </div>
        )}

        <button
          type="submit"
          className={`${GeneralData.style.layout.button(
            'primary'
          )} gap-2 flex-none`}
        >
          Enviar <FaPaperPlane className="inline" />
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
